var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',{staticClass:"picture",style:({ height: _vm.height, opacity: _vm.opacity }),attrs:{"data-iesrc":_vm.localFallbackSrc,"data-alt":_vm.localAlt}},[(_vm.sources.length)?_vm._l((_vm.sources),function(ref,i){
var srcset = ref.srcset;
var type = ref.type;
return _c('source',{key:i,attrs:{"srcset":srcset,"type":type}})}):_c('source',{attrs:{"srcset":_vm.localFallbackSrc}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }